<template>
	<div class="editor-wrapper">
		<div style="display:flex;padding-right: 1%;">
			<v-spacer></v-spacer>
			<v-btn @click="deleteMeta" outline color="red darken-1" medium
				>Delete</v-btn
			>
			<v-btn @click="formatMeta" outline color="blue darken-1" medium
				>Format</v-btn
			>
			<v-btn @click="updateMeta" outline color="green darken-1" medium
				>Update</v-btn
			>
		</div>
		<div>
			<brace
				class="kbet-editor"
				style="height:90vh;width:100vw"
				:mode="'json'"
				@code-change="onEditorCodeChange"
				@setHandler="
					h => {
						editorHandler = h;
					}
				"
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
	components: {},
	created() {},
	data() {
		return {
			editorCode: '',
			editorHandler: false,
		};
	},
	methods: {
		...mapActions('stockist', ['updateStockistMeta', 'deleteStockistMeta']),
		...mapMutations(['openSnackbar', 'openLoaderDialog', 'closeLoaderDialog']),
		...mapMutations('stockist', [
			'closeFileMetaDialog',
			'refreshStockistListEmitter',
		]),
		// ...mapMutations("stockist", ["closeFileMetaDialog"]),
		onEditorCodeChange(code) {
			this.editorCode = code;
		},
		jsonValidate(json) {
			try {
				JSON.parse(json);
				return true;
			} catch (err) {
				return false;
			}
		},
		getConfig() {
			let config = JSON.parse(this.editorCode);
			config._id = this.selectedStockistMeta._id;
			config.name = this.selectedStockistMeta.name;
			config.stockist_code = this.selectedStockistMeta.stockist_code;
			return config;
		},
		formatMeta() {
			if (this.jsonValidate(this.editorCode)) {
				let config = this.getConfig();
				this.editorHandler.setValue(JSON.stringify(config, null, 2));
			} else {
				this.openSnackbar({
					text: 'Invalid JSON Format',
				});
			}
		},
		updateMeta() {
			if (this.jsonValidate(this.editorCode)) {
				let config = this.getConfig();
				this.openLoaderDialog();
				this.updateStockistMeta({ meta: config }).then(data => {
					this.closeLoaderDialog();
					if (data) {
						this.openSnackbar({
							text: 'Updated Stockist Meta',
						});
					} else {
						this.openSnackbar({
							text: 'Failed to update Stockist Meta',
						});
					}
				});
			} else {
				this.openSnackbar({
					text: 'Invalid JSON Format',
				});
			}
		},
		deleteMeta() {
			if (window.confirm('Are you sure you want to delete this meta')) {
				if (this.jsonValidate(this.editorCode)) {
					let config = this.getConfig();
					this.openLoaderDialog();
					this.deleteStockistMeta({ _id: config._id }).then(data => {
						this.closeLoaderDialog();
						if (data) {
							this.openSnackbar({
								text: 'Deleted Stockist Meta',
							});
							this.refreshStockistListEmitter();
							this.closeFileMetaDialog();
						} else {
							this.openSnackbar({
								text: 'Failed to delete Stockist Meta',
							});
						}
					});
				} else {
					this.openSnackbar({
						text: 'Invalid JSON Format',
					});
				}
			}
		},
	},
	computed: {
		...mapGetters(['getSelectedDates']),
		...mapGetters('stockist', ['selectedStockistMeta']),
	},
	mounted() {
		// console.log(this.selectedStockistMeta);
		this.editorHandler.setValue(
			JSON.stringify(this.selectedStockistMeta, null, 2)
		);
	},
};
</script>

<style lang="scss" scoped></style>
